import { DS_setData } from '../DS/DS.Data'
import { LS_userSet } from '../LS/LS.user'
import { Serv_send } from '../Serv/Serv.socketClient'
import { User_get, User_isLoggedIn } from './User.get'
import type { User_IUser } from './User.IUser'
import type { SupportedLanguage } from '../../../shared/i18n/i18n.no-deps'
import { Translations } from '../../../shared/i18n/Translations'
import * as ZendeskWebChat from '../../../app-core/lib/util/zendeskWebChat'

async function User_updateLocally(label: string, changes: Partial<User_IUser>) {
    if (!User_isLoggedIn()) return
    const user = { ...User_get(), ...changes }

    // Update in memory
    DS_setData(label, () => ({ user }))

    // Save to disk locally
    LS_userSet(user)
}

export async function User_totalPointsUpdate(totalPoints: number) {
    await User_updateLocally('TotalPointsUpdated', { totalPoints })
}

export async function User_personaliseUpdate(audioTheme: string, vibrate: string) {
    const prefs = {
        ...User_get().prefs,
        audio_theme: audioTheme,
        vibrate,
    }
    await User_updateLocally('PersonaliseUpdated', { prefs })
    await Serv_send('user.update', { prefs })
}

export async function User_languageUpdate(language: SupportedLanguage) {
    await Translations.changeLanguage(language)
    await User_updateLocally('LanguageUpdated', { language })
    await Serv_send('user.update', { language })
    ZendeskWebChat.setLocale(language) // Zendesk Chat
}
